<template>
  <f7-page class="settings-page">
    <template #fixed>
      <ProfileNavigationComponent :title="$t.getTranslation('LBL_REFERRAL')" type="back" :settings="false" />
    </template>

    <section class="referral-section">
      <div class="container">
        <div v-if="referralList.length > 0" class="referral-list userinfo">
          <div v-for="referral in referralList" :key="'rf_' + referral.UserId" class="referral">
            <div class="info">
              <div>
                <h1>{{ $h.getFullName(referral) }}</h1>
                <p class="contact">{{ $h.formatMobile(referral) }}</p>
              </div>
              <div class="order">
                <span>{{ referral.UserName || "--" }}</span>
                <p>{{ referral.Email || "--" }}</p>
              </div>
            </div>
            <div v-if="referral?.UserGroupId > 1" class="commission-info">
              <div>
                <p>{{ $t.getTranslation("LBL_ELIGIBLE_COMMISSION_AMOUNT") }}</p>
                <p>{{ $h.formatNumber(referral.TotalEligibleCommissionAmount) }}</p>
              </div>
              <div>
                <p>{{ $t.getTranslation("LBL_REDEEMABLE_COMMISSION_AMOUNT") }}</p>
                <p>{{ $h.formatNumber(referral.TotalRedeemableCommissionAmount) }}</p>
              </div>
              <div>
                <p>{{ $t.getTranslation("LBL_REDEEMED_COMMISSION_AMOUNT") }}</p>
                <p>{{ $h.formatNumber(referral.TotalRedeemedCommissionAmount) }}</p>
              </div>
            </div>
          </div>
        </div>

        <NoDataFoundComponent v-else :size="'sm'" :title="$t.getTranslation('LBL_USERS_EMPTY')" />
      </div>
    </section>
  </f7-page>
</template>

<script>
import { defineComponent, onMounted, ref, defineAsyncComponent } from "vue";

import { get } from "@/utils/axios";

import { useStore } from "@/store";

// import ProfileNavigationComponent from "@/components/navigations/ProfileNavigationComponent.vue";
// import NoDataFoundComponent from "@/components/NoDataFoundComponent.vue";

const ProfileNavigationComponent = defineAsyncComponent(() => import(/* webpackChunkName: "profile-nav" */ /* webpackMode: "lazy" */ "@/components/navigations/ProfileNavigationComponent.vue"));
const NoDataFoundComponent = defineAsyncComponent(() => import(/* webpackChunkName: "no-data" */ /* webpackMode: "lazy" */ "@/components/NoDataFoundComponent.vue"));


export default defineComponent({
  name: "ReferralListPage",
  components: {
    ProfileNavigationComponent,
    NoDataFoundComponent,
  },
  props: { f7router: Object },
  setup(props) {
    const referralList = ref([]);

    const store = useStore();
    
    const getReferralList = async () => {
      let returnData = await get("/user/referral/list");
      referralList.value = returnData;
    };

    onMounted(() => {
      getReferralList();
    });

    return {
      referralList,
    };
  },
});
</script>
